$(function () {
    // полифил для инвалидов
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (css) {
            var node = this;

            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }

    //выцепляем яблоки, вешаем класс
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        $("body").addClass("ios")
    }

    //управляем появлением/скрытием дропов
    $(".dropdown_nav_close").on("click", function () {
        $(".dropdown_nav").fadeOut(250);
    });

    $(".main_nav__block--brands ul").find("li").click(function () {
        $(this).find(".dropdown_nav").fadeIn("300");
        $("li").not(this).find(".dropdown_nav").fadeOut("300");
        $(".dropdown_nav").click(function (e) {
            e.stopPropagation();
        });
    });

    //скрываем алерты
    $(".alert_close").on("click", function () {
        $(".alert").slideUp(250);
    });

    //показываем опции
    $("button.btn_buy").on("click", function () {
        $('.product_card_active')
            .removeClass("product_card_active")
            .find(".product_card_options")
            .slideUp(250);
        $(this)
            .closest(".product_card")
            .addClass("product_card_active")
            .find(".product_card_options")
            .slideDown(250);
    });

    //скрываем опции
    $(".options_close").on("click", function () {
        $(this)
            .closest(".product_card")
            .removeClass("product_card_active")
            .find(".product_card_options")
            .slideUp(250);
    });

    //плавный скроллинг до якоря
    var documentIsScrolled = false;
    $(".slide_to").on("click", function (e) {
        var scrollSize = $($(this).attr("href")).offset().top,
            diff = $(window).scrollTop() - scrollSize;

        if (!documentIsScrolled) {

            documentIsScrolled = true;
            if (diff > 20 || diff < -20) {

                $("body, html").animate({
                    scrollTop: scrollSize
                }, 800, function () {
                    documentIsScrolled = false;
                });
            } else {
                documentIsScrolled = false;
            }
        }

        e.preventDefault();
    });

    //события при скролле
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            $('.btn_to_top').addClass("btn_to_top_sticky");
        } else {
            $('.btn_to_top').removeClass("btn_to_top_sticky");
        }
        if ($(this).scrollTop() > 50) {
            $('.header_topline').addClass("header_topline--sticky");
        } else {
            $('.header_topline').removeClass("header_topline--sticky");
        }
    });

    //плавающая корзина
    // $(".sticky_basket").sticky({topSpacing: 0});

    //дропдаун лич.каба в шапке
    $(".header_userblock_dropdown").on("click", function () {
        $(".header_userblock_nav").slideToggle(200);
        $(".header_userblock_dropdown").toggleClass('header_userblock_dropdown_open');
    });

    //вызов галерей
    $('.gallery').lightGallery({
        selector: 'a'
    });

    var $galleries = $('.slider_gallery');
    //слайдер + галерея
    $galleries.lightSlider({
        adaptiveHeight: true,
        gallery: true,
        item: 1,
        loop: true,
        slideMargin: 0,
        thumbMargin: 10,
        enableTouch: false,
        enableDrag: false,
        freeMove: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    thumbItem: 3
                }
            }
        ],
        onSliderLoad: function (slider) {
            var $slider = $(slider);
            if ($slider.css('display') === 'none') {
                var $no_display = $slider.css({'display': '', 'height': ''})
                    .closest('.lSSlideOuter').css({'display': 'none'});

                $no_display
                    .find('.lSSlideWrapper').addClass('slider_border');
            } else {
                $slider.css({'display': '', 'height': ''})
                    .closest('.lSSlideOuter')
                    .find('.lSSlideWrapper')
                    .addClass('slider_border');
            }
        }
    });

    //табы
    (function ($) {
        $(".tabs_categories li a").click(function (g) {
            var tab = $(this).closest(".tabs"),
                index = $(this).closest("li").index();

            tab.find(".tabs_categories > li").removeClass('current');
            $(this).closest("li").addClass("current");

            tab.find(".tab_content").find(".tabs_item").not(".tabs_item:eq(" + index + ")").slideUp(100);
            tab.find(".tab_content").find(".tabs_item:eq(" + index + ")").slideDown(100);

            g.preventDefault();
        });
    })(jQuery);

    //аккордион
    if ($(".accordion").length) {

        var $accordionTitle = $('.accordion_title', '.accordion');
        $('.accordion_item_active').addClass('accordion_item_open');

        $accordionTitle.on('click', function (e) {
            var item = $(this).closest('.accordion_item');
            if (!item.hasClass('accordion_item_open')) {
                $(".accordion_item_open").removeClass("accordion_item_open");
            }
            item.toggleClass('accordion_item_open');
            e.preventDefault();
        });
    }

    if ($('#js-contacts-map').length) {
        ymaps.ready(function () {
            var myMap = new ymaps.Map('js-contacts-map', {
                center: [56.0175, 92.85],
                zoom: 12
            }, {
                searchControlProvider: 'yandex#search'
            }), placemarks = [];

            myMap.behaviors.disable('scrollZoom');

            function activateBlock(item, targetLink, scroll) {
                $('.contact_block_active').removeClass('contact_block_active');
                $(targetLink).addClass('contact_block_active');
                if (scroll) {
                    $("html, body").animate({
                        scrollTop: $("#js-contacts-map").offset().top
                    }, 500);
                }
                var coord_x = parseFloat(item.dataset.pointX),
                    coord_y = parseFloat(item.dataset.pointY),
                    index = item.dataset.index
                ;
                if (coord_x && coord_y) {
                    myMap.panTo([
                        [coord_x, coord_y]
                    ]);
                    placemarks.map(function (mark) {
                        if (mark.properties.get('iconContent') === index) {
                            mark.options.set(
                                'iconContentLayout',
                                ymaps.templateLayoutFactory.createClass(
                                    '<div class="map_marker">$[properties.iconContent]</div>'
                                )
                            );
                            mark.options.set('iconImageHref', '/static/i/map_label_active.png');
                        } else {
                            mark.options.set(
                                'iconContentLayout',
                                ymaps.templateLayoutFactory.createClass(
                                    '<div class="map_marker map_marker_white">$[properties.iconContent]</div>'
                                )
                            );
                            mark.options.set('iconImageHref', '/static/i/map_label.png');
                        }
                    });
                }
            }

            $('.js-contact-point').each(function (i, item) {
                var coord_x = parseFloat(item.dataset.pointX),
                    coord_y = parseFloat(item.dataset.pointY);
                if (coord_x && coord_y) {
                    var placemark = new ymaps.Placemark([
                        coord_x,
                        coord_y
                    ], {
                        balloonContent: item.dataset.content,
                        iconContent: item.dataset.index
                    }, {
                        iconLayout: 'default#imageWithContent',
                        iconImageHref: '/static/i/map_label.png',
                        iconImageSize: [28, 38],
                        iconImageOffset: [-14, -38],
                        iconContentOffset: [9, 9],
                        iconContentLayout: ymaps.templateLayoutFactory.createClass(
                            '<div class="map_marker map_marker_white">$[properties.iconContent]</div>'
                        )
                    });
                    myMap.geoObjects.add(placemark);
                    placemarks.push(placemark);

                    placemark.events.add('click', function (e) {
                        activateBlock(item, $(item).find('.js-marker_link'), false);
                    });
                }


                $(item).find('.js-marker_link').on('click', function (e) {
                    e.preventDefault();
                    activateBlock(item, this, true);
                });

            });
        });
    }

    $('.js-soc-link').on('click', function (e) {
        e = (e ? e : window.event);
        var t = (e.target ? e.target : e.srcElement),
            width = t.data - width || 800,
            height = t.data - height || 500;

        // popup position
        var px = Math.floor(((screen.availWidth || 1024) - width) / 2),
            py = Math.floor(((screen.availHeight || 700) - height) / 2);

        // open popup
        var popup = window.open(t.href, "social",
            "width=" + width + ",height=" + height +
            ",left=" + px + ",top=" + py +
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

        return !!popup;
    });


    var forms = document.querySelectorAll('form.js-form');
    forms.forEach(function (form) {
        var ajax_form = new TurboForm(form, {
            showErrorAfterInput: true
        });
        ajax_form.showErrorMessage = function (message) {
            if (this.errorBox) {
                if (this.form.name === 'login') {
                    this.errorBox.querySelector('.js-content').innerHTML = message;
                } else {
                    this.errorBox.innerHTML = message;
                }
                this.errorBox.style.display = 'block';
            }
        };

        ajax_form.showSuccessMessage = function (message) {
            if (['login', 'register'].indexOf(this.form.name) >= 0) {
                setTimeout(function () {
                    window.location.href = '/';
                }, 500);
                this.messageBox.style.display = 'none';
                return;
            }
            if (this.messageBox) {
                this.messageBox.innerHTML = message || 'Сообщение успешно отправлено';
                this.messageBox.style.display = 'block';
            }
            if (this.form.classList.contains('js-close-after-success')) {
                var close = this.form.closest('.remodal').querySelector('.remodal_close');
                if (close) {
                    setTimeout(function () {
                        close.click();
                    }, 1000);
                }
            }
        };
    });

    var comment_form = document.querySelector('.js-comment-form');
    if (comment_form) {
        var comment_list = document.querySelector('.comments_list');
        comment_form = new TurboForm(comment_form, {
            unholdFormAfterSuccess: true
        });
        comment_form.showSuccessMessage = function (message) {
            var div = document.createElement('div');
            div.innerHTML = message;
            div = div.firstElementChild;
            comment_list.insertBefore(div, comment_list.firstChild);
            this.reset();
        };
    }

    var $cards = $('.product_card_form, .js-card-form');
    FlavorSelectActivate($cards);
    CardEventsActivate($cards);
    activateCardUi($('body'));

    var $input = $("input[name=phone]");
    if ($input.length) {
        $input.mask("+7 (999) 999-99-99",{
          "clearIncomplete": false,
          "inputmode": "numeric",
          "onincomplete": function(){ alert('введите номер телефона'); }
        }).attr('pattern','^\\+7\\s?\\(?\\d{3}\\)?\\s?\\d{3}-\\d{2}-\\d{2}$');
      $input.on("paste", function (e) {
        const $input = $(this);
        var pastedNumber = e.originalEvent.clipboardData.getData('Text');
        if (pastedNumber) {
          e.preventDefault();
          const changedNumber = pastedNumber.replace(/^8/, "").replace(/^\+7/, "")
          $input.val(changedNumber).trigger('change');
        }
      });
      $input.on("input", function (e) {
        const $input = $(this);
        var pastedNumber = $input.val();
        if (pastedNumber && pastedNumber.length > 10) {
          e.preventDefault();
          const changedNumber = pastedNumber.replace(/^8/, "").replace(/^\+7/, "")
          if (changedNumber.length === 10) {
            $input.val(changedNumber).trigger('change');
          }
        }
      });
    }

    // шоб шапка не прыгала при открытии модалки
    var $header = $('.header_topline'),
        $window = $(window),
        baseWidth = 0;

    baseWidth = $window.width();

    $(document).on('opening', '.remodal', function () {
        $header.css({
            paddingRight: $window.width() - baseWidth + 'px'
        });
    });

    $(document).on('closed', '.remodal', function (e) {
        $header.css({paddingRight: ''});
    });

    $('.js-v-number').on('input', function (e) {
        var num = Math.abs(parseInt(e.target.value));
        e.target.value = isNaN(num) ? '' : num;
    });


    var renderItems = $('.js-products-cards-render');
    if (renderItems.length) {
        var ids = {};
        renderItems.map(function (i, item) {
            try {
                ids[i] = JSON.parse(item.dataset.ids);
            } catch (e) {
            }
        });

        $.post('/api/get-products/', {
            ids: ids
        }, function (resp) {
            if (resp.success) {
                resp.data.map(function (item, i) {
                    var html = $(renderItems[i]);
                    html.html(item);
                    activateCards(html);
                    FlavorSelectActivate(html.find('form'));
                    CardEventsActivate(html);
                    activateCardUi(html);
                })
            }
            Cart.onInitCallback();
        })
    }

    var list = $('.js-sagest-list'),
        timeout = null;
    $('.js-search').on('input change', function (e) {
        var value = e.target.value;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $.getJSON('/search/sagest/', {
                q: value
            }, function (resp) {
                if (resp.success) {
                    list.html(resp.html);
                    list.show();
                } else {
                    list.hide();
                }
            });
        }, 500);
    })

  $(".scroll_to").on('click', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    if (href) {
      $([document.documentElement, document.body]).animate({
        scrollTop: ($(href).offset().top - 70)
      }, 2000);
    }
  });

  $('.click_phone').on('click', function (e) {
    yaCounterEvent('click_phone')
  })

  // проверяем модалку телеграма
  checkTelegramModal();
});

window.products_groups = {};

function activateCards(html) {
    html.find("button.btn_buy").on("click", function () {
        $('.product_card_active')
            .removeClass("product_card_active")
            .find(".product_card_options")
            .slideUp(250);
        $(this)
            .closest(".product_card")
            .addClass("product_card_active")
            .find(".product_card_options")
            .slideDown(250);
    });
    html.find(".options_close").on("click", function () {
        $(this)
            .closest(".product_card")
            .removeClass("product_card_active")
            .find(".product_card_options")
            .slideUp(250);
    });
}

function getItemInGroupByVolume(product_id, volume, flavor) {
    if (product_id) {
        var result;
        for (var flavor_item in window.products_groups[product_id]) {
            if (flavor === flavor_item || !flavor) {
                window.products_groups[product_id][flavor_item].map(function (item) {
                    if (volume == item.volume) {
                        result = item;
                    }
                });
                if (result) {
                    return result;
                }
            }
        }
    }
    return null;
}

function getItemInGroupById(id) {
    var result;
    for (var group_id in window.products_groups) {
        for (var flavor in window.products_groups[group_id]) {
            window.products_groups[group_id][flavor].map(function (item) {
                if (id == item.id) {
                    result = item;
                }
            });
            if (result) {
                return result;
            }
        }
    }
    return null;
}

function CardEventsActivate($items) {
    $('.count_minus', $items).on('click', function (e) {
        var $input = $(this).siblings('.count_input'),
            value = parseInt($input.val());
        if (!value || value <= 1) {
            value = 1;
        } else {
            value -= 1;
        }
        $input.val(value);
    });

    $('.count_plus', $items).on('click', function (e) {
        var $input = $(this).siblings('.count_input'),
            value = parseInt($input.val());
        if (!value) {
            value = 1;
        } else {
            value += 1;
        }
        $input.val(value);
    });
}

/**
 * Полифил на для браузеров инвалидов
 */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function FlavorSelectActivate(forms) {
    forms.map(function (i, form) {
        form = $(form);
        var item = form.find('.js-flavor-select'),
            volume = form.find('.js-volume-select'),
            volume_text = form.attr('data-volume-text'),
            flavor_text = form.attr('data-flavor-text'),
            cur_flavor = item.val(),
            cur_volume = null,
            groups = null,
            $product = form.closest('.js-product')
        ;

        try {
            if (item.length) {
                groups = JSON.parse(item.attr('data-groups'));
            } else {
                groups = JSON.parse(volume.attr('data-groups'));
            }
        } catch (e) {
            console.log(e);
            groups = null;
        }

        var product_id = parseInt($product.attr('data-product-id'));
        if (product_id) {
            window.products_groups[product_id] = groups || {};
        }

        var inBasket = $product.hasClass('product_card_basket');

        if (groups !== null) {
            item.on('change', function (e) {
                var html = '<option value="0" disabled>выберите ' + volume_text + '</option>';
                cur_flavor = e.target.value;
                if (groups.hasOwnProperty(cur_flavor)) {
                    groups[cur_flavor].map(function (v) {
                        html += '<option value="' + v.volume + '"' + (v.total_count > 0 ? '' : ' disabled') + '>' + v.volume + '</option>';
                    });
                }
                volume.html(html);
                volume.prop('disabled', false);
                volume.change();
                if (!cur_flavor) {
                    form.find('.js-card-alert').html('Выберите ' + flavor_text).slideDown();
                }
            });

            var default_img = $product.find('.product_card_img img').attr('src');
            volume.on('change input', function (e) {
                cur_volume = e.target.value;
                var item = getItemInGroupByVolume(product_id, cur_volume, cur_flavor);
                if (item) {
                    form.find('.product_price_actual').text(Meta.beautyPrice(item.price) + ' ₽');

                    var price = $product.find('.actual_price span');
                    if (price.length) {
                        price.text(Meta.beautyPrice(item.price) + ' ₽');
                    } else {
                        $product.find('.actual_price').text(Meta.beautyPrice(item.price) + ' ₽');
                    }

                    if (item.sale) {
                        $product.find('.old_price').show().find('span').text(item.no_sale_price + ' ₽');
                        $product.find('.product_price_old').text(item.no_sale_price + ' ₽').show();
                        $product.find('.js-price-sale').show();
                        $product.find('.js-price-normal').hide();
                        $product.find('.card_price').addClass('card_price_action');
                    } else {
                        $product.find('.old_price').hide();
                        $product.find('.product_price_old').hide();
                        $product.find('.js-price-normal').show().text(item.no_sale_price + ' ₽');
                        $product.find('.js-price-sale').hide();
                        $product.find('.card_price').removeClass('card_price_action');
                    }
                    if (item.images.length) {
                        var img = item.images[0].small;
                        if (img) {
                            $product.find('.product_card_img img').attr('src', img);
                        } else {
                            $product.find('.product_card_img img').attr('src', default_img);
                        }
                    } else {
                        $product.find('.product_card_img img').attr('src', default_img);
                    }

                    var old = parseInt($product.attr('data-id'));

                    $product
                        .attr('data-id', item.id)
                        .attr('data-variant', cur_flavor)
                        .attr('data-price', item.price);


                    if ($product.data('is_item')) {
                      var href = window.location.href;
                      history.replaceState({}, null, href.replace(/(catalog\/[-\w\.]+)\/?(\d+)?\/?/gmi, '$1' + '/' + item.id + '/'));

                      if (typeof (sendDatalayer) !== 'undefined') {
                            if (typeof (getItemForDatalayer) !== 'undefined') {
                                const id = getProductModId($product),
                                    price = getProductPrice($product),
                                    title = getProductTitle($product),
                                    variant = getProductModVariant($product),
                                    category = getProductCategory($product),
                                    brand = getProductBrand($product)
                                ;
                                const dataDL = {
                                    id: id,
                                    price: price,
                                    brand: brand,
                                    category: category,
                                    variant: variant,
                                    title: title
                                };
                                const itemDatalayer = getItemForDatalayer(dataDL);
                                sendDatalayer('view_item', [itemDatalayer]);
                            }
                        }
                    }

                    if ($product.hasClass('product_card_basket')) {
                        old = Cart.getItemById(old);
                        var items_count = Cart.items.length;
                        Cart.removeItem(old, function () {
                            Cart.putItem({
                                id: item.id,
                                price: item.price,
                                qty: old.qty,
                                product_id: product_id
                            }, true, function () {
                                if (inBasket && Cart.items.length < items_count) {
                                    $product.slideUp(500, function () {
                                        $(this).remove();
                                    });
                                }
                                updateCartBlock();
                                updateCartPage();
                            });
                        });
                    }

                    var markets = $('.product_available_list');
                    if (markets.length && item.stocks.length) {
                        var html_li = '';
                        item.stocks.map(function (stock) {
                            html_li += '<li class="product_available_item">' + stock.title + ' - <strong>' + stock.count + '</strong></li>';
                        });
                        markets.html(html_li);
                    }
                }
                if (cur_volume && item) {
                    if (item.in_stock) {
                        form.find('.js-card-alert').slideUp();
                        var btn = form.find('.js-cart_buy');
                        if (btn.length) {
                            btn.prop('disabled', false);
                            if (!btn.hasClass('btn_add_basket')) {
                                btn.text('> купить').off('click');
                                activateCardUi($product);
                            }
                        }
                    } else {
                        form.find('.js-card-alert').html('Товара нет в наличии').slideDown();
                        form.find('.js-cart_buy').prop('disabled', true);
                    }
                } else {
                    form.find('.js-card-alert').html('Выберите ' + volume_text).slideUp();
                }
            });

            if (!inBasket) {
                if (item.length) {
                    var enabledOptions = item.find('option').filter(function (i, item) {
                        return item.disabled === false;
                    });
                    if (enabledOptions.length) {
                        // если товар без скидки то выбираем первый
                        if ($product.data('sale') === false || enabledOptions.length === 1) {
                            item.val(enabledOptions[0].value);
                            item.change();
                            volume.change();
                        }
                        // по идее надо выбирать первую модификацию со скидкой
                    } else {
                        form.find('.js-card-alert').html('Товара нет в наличии').slideDown();
                    }
                } else {
                    var enabledVolumeOptions = volume.find('option').filter(function (i, item) {
                        return item.disabled === false;
                    });
                    if (enabledVolumeOptions.length) {
                        volume.val(enabledVolumeOptions[0].value);
                        volume.change();
                    } else {
                        form.find('.js-card-alert').html('Товара нет в наличии').slideDown();
                    }
                }
            }
        }
    });
}

function yaCounterEvent(target_name) {
    console.log('send new reach goal=' + target_name);

    if (typeof (ym) != 'undefined')
        ym(88692299, 'reachGoal', target_name);

    // var _tmr = window._tmr || (window._tmr = []);
    // _tmr.push({ id: "3074232", type: "reachGoal", goal: target_name });

    if (typeof (gtag) != 'undefined')
        gtag('event', target_name);

    if (typeof (fbq) != 'undefined')
        fbq('track', 'Lead');

};

function sendDatalayer(event, items, orderInfo) {
    if (event && items) {
        console.log('send event=' + event + ' ecommerce=');
        var ecommerceObj = new Object();
        if (typeof (orderInfo) !== 'undefined' && orderInfo) {
            ecommerceObj = orderInfo;
        }
        ecommerceObj.items = items;

        console.log(ecommerceObj);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: event,
            ecommerce: ecommerceObj
        });
    }
}

function getItemForDatalayer(data, qty) {
    if (typeof (qty) === 'undefined') {
        qty = 1;
    }
    var item = {
        // item_name: data.title,
        item_id: data.id,// Name or ID is required.
        // price: data.price,
        quantity: qty
        // category: data.category,
        // variant: data.variant,
        // brand: data.brand
    };
    if (data.title) {
        item['item_name'] = data.title
    }
    if (data.price) {
        item['price'] = data.price
    }
    if (data.category) {
        item['category'] = data.category
    }
    if (data.variant) {
        item['variant'] = data.variant
    }
    if (data.brand) {
        item['brand'] = data.brand
    }

    return item;
}

function checkTelegramModal() {
  // Всплывашка на переход в телегу,
  // не показывается, если юзер закрыл эту всплываху
  // Смотрим localStorage
  if ($('[data-remodal-id=telegram]').length > 0) {
    var $remodal = $('[data-remodal-id=telegram]').remodal();
    var cookie_modal = 'telegram_close';
    if (getCookie(cookie_modal) == null) {

      if (!sessionStorage.getItem('startTime')) {
        sessionStorage.setItem('startTime', Date.now());
      }

      var enterTime = sessionStorage.getItem('startTime');

      function showTelegramModal () {
        var currentTime = Date.now();
        var spentTime = (currentTime - enterTime) / 1000;
        if (spentTime >= 10) {
          clearInterval(timer);
          $remodal.open();

          $(document).on('closing', '[data-remodal-id=telegram]', function (e) {
            setCookie(cookie_modal,'true', 30);
          })
        }
      }
      var timer = setInterval(showTelegramModal, 3000);

    } else {
      $remodal.destroy();
    }
  }
};
